const routes = {
  createPaymentHead: 'payment-head',
  getPaymentHeads: 'payment-head',
  getPaymentHeadById: 'payment-head/',
  updatePaymentHead: 'payment-head/',
  deletePaymentHead: 'payment-head/',
};

export default routes